export default "__VITE_ASSET__4bpRKAn3__"